import { useTranslations } from 'next-intl';
import { twMerge } from 'tailwind-merge';
import { COLORS } from '@/common/constants';
import Sidebar from '../Sidebar';
import SurveyForm from '../SurveyForm';

export default function KhaoSat({ websiteCode, locale, rightBanners, linkPages }) {
  const t = useTranslations('');
  return (
    <div className="flex flex-col min-h-screen">
      <div className="container mx-auto  mt-5 flex-grow">
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-3/4 ">
            <h1 className={twMerge('text-2xl font-bold mb-6 uppercase  pb-2', COLORS.primary)}>{t('survey.survey')}</h1>
            <SurveyForm websiteCode={websiteCode} locale={locale} />
          </div>

          <div className="w-full md:w-1/4 ">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </div>
        </div>
      </div>
    </div>
  );
}
